import { render, staticRenderFns } from "./GameIcon.vue?vue&type=template&id=2c0073e5&scoped=true"
import script from "./GameIcon.vue?vue&type=script&lang=js"
export * from "./GameIcon.vue?vue&type=script&lang=js"
import style0 from "./GameIcon.vue?vue&type=style&index=0&id=2c0073e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0073e5",
  null
  
)

export default component.exports